import PsychologistImages from '../images/psychologist';

const psychologistList = [
  {
    name: 'Dr. Livia Istania DF Iskandar, M.Sc., Psikolog',
    skills: ['Anxiety', 'Youth', '+5'],
    skills_detail: [
      'Gender-based Violence',
      'Depression',
      'Post Traumatic Stress Disorder (PTSD)',
      'Anxiety',
      'English-speaking Clients',
      'Youth',
      'Work-family Balance',
    ],
    photo: PsychologistImages.Livia,
    alt: 'Ibu Livia',
    slug: 'livia-istania',
    profile: `Lulusan Fakultas Psikologi Universitas Indonesia (1988-1994). Mendapatkan gelar Master of Science-nya dalam Psychological Counseling dari City University, London (1996-1997). Mendapatkan gelar Doctor of Public Health (DrPH) dari Universitas Hawaii di Manoa dengan beasiswa penuh dari East West Center (2009-2012).

    Livia Iskandar memiliki pengalaman diantaranya sebagai Manajer Nasional untuk Program Kekerasan terhadap Perempuan UNFPA dan UNIFEM. Menjadi Koordinator Pengembangan Sistem Layanan bagi Penyintas Kekerasan di Komisi Nasional Anti Kekerasan terhadap Perempuan. Livia Iskandar juga sebagai salah satu founder Yayasan Pulih dan pada tahun 2014 mendirikan Pulih@thePeak bersama dengan rekannya.`,
  },
  {
    name: 'Soraya Salim, S.Psi., Psikolog',
    skills: ['Alzheimer', 'Caregiver', '+3'],
    skills_detail: [
      'Youth (School-related problems)',
      'Couples Counseling',
      'Alzheimer and Caregiver',
      'English-speaking Clients',
      'Experienced in Market Research and Corporate',
    ],
    photo: PsychologistImages.Aya,
    alt: 'Ibu Soraya',
    slug: 'soraya-salim',
    profile: `Lulusan Fakultas Psikologi Universitas Indonesia. Menjadi psikolog relawan Yayasan Pulih yang bergerak di bidang pemulihan paska trauma sejak tahun 2005 dan menjadi Project Leader kerjasama Yayasan Pulih dengan UN Women untuk kampanye Stop Violence Against Women and Girls.

    Pada tahun 2014, Soraya Salim mendirikan Pulih@thePeak bersama dengan rekannya, Livia Iskandar, yang juga adalah seorang psikolog senior. Soraya Salim memiliki pengalaman kerja diantaranya sebagai konsultan pada Daya Dimensi Indonesia terkait bidang assessment dan sebagai researcher pada Asia Market Intelligence.`,
  },
  {
    name: 'Abas Supeli, S.Psi., M.Sc., Ph.D., Psikolog',
    skills: ['Psikologi Klinis terutama Couple Relationship'],
    skills_detail: ['Psikologi Klinis terutama Couple Relationship'],
    photo: PsychologistImages.Abas,
    alt: 'Bapak Abas',
    slug: 'abas-supeli',
    profile: `Lulusan Fakultas Psikologi Universitas Padjajaran dan Program Master of Science dari Leiden University. Memulai karirnya sebagai psikolog klinis dengan menjadi asisten dosen pada bidangnya. Berpengalaman pada bidang sumber daya manusia di berbagai perusahaan bertaraf makro-nasional dan menjadi assessor bagi perusahaan multi-nasional.
    
    Mendapatkan beasiswa program Master melalui StuNed (Studeren In Nederland) dimana dia mendalami “Health Psychology” yang dapat diimplementasikan di Indonesia sebagai kombinasi antara Psikologi Klinis dan Psikologi Industri dan Organisasi. Abbas Supeli mengambil gelar doctoral di Universitas Griffith Australia dan menjadi anggota MAREAA (Marriage and Relationship Educators Association of Australia).`,
  },
  {
    name: 'Agustina Indrawati, M.Psi., Psikolog',
    skills: ['Stres dan Kesehatan', 'Depresi', 'Pengembangan Diri'],
    skills_detail: [
      'Stres, gangguan kecemasan, depresi dan trauma',
      'Pengembangan diri, relasi interpersonal, relasi pranikah/pasangan/keluarga',
      'Pengembangan karir, performa dan relasi di dunia kerja',
    ],
    photo: PsychologistImages.Agustina,
    alt: 'Ibu Agustina',
    slug: 'agustina-indrawati',
    profile: `Lulusan Fakultas Psikologi serta Program Studi Magister Psikologi Profesi bidang Psikologi Industri dan Organisasi dari Universitas Indonesia. Menyelesaikan program Loop Certified Professional Coach dan Hogan Assessment Certification. Anggota himpunan Psikologi Indonesia dan Ikatan Psikolog Klinis Indonesia.

    Saat ini melakukan pelayanan/praktik Psikologi Klinis serta Konseling terkait peningkatan kesehatan mental pada klien remaja dan dewasa. Selain itu, menjalankan aktivitas coaching untuk menemukan kehidupan yang lebih bermakna (life coaching) maupun coaching karir. Menjadi contributor lepas serial psikoedukasi “Anak Muda Keren Paham KesMen (Kesehatan Mental)” di situs web Kompasiana.

    Agustina Indrawati juga terlibat dalam aktivitas Employee Wellness Program bagi klien di lingkup organisasi yang bertujuan menjaga kesehatan mental dan memelihara kesejahteraan (wellbeing) karyawan maupun anggota keluarganya. Memili pengalaman kerja sebagai Praktisi SDM di beberapa perusahaan multinasional dan organisasi internasional, seperti World Bank Group dan United Nations.`,
  },
  {
    name: 'Wulan Ayu Ramadhani, M.Psi, Psikolog, CHt',
    skills: ['Anxiety', 'Depression', '+4'],
    skills_detail: [
      'A Licensed Clinical Psychologist providing Psychotherapy',
      'Depression',
      'Anxiety',
      'Trauma’s impact on Relationships',
      'Couple Counseling',
      'Gender-based violence',
    ],
    photo: PsychologistImages.Wulan,
    alt: 'Ibu Wulan',
    slug: 'wulan-ayu',
    profile: `Lulusan Fakultas Psikologi dan Magister Profesi Klinis Dewasa Universitas Indonesia. Ia sudah menjadi praktisi Psikolog Klinis sejak tahun 2008 dan menangani banyak kasus yang berkaitan dengan kecemasan, depresi, trauma dalam relasi, serta isu-isu perkawinan dan keluarga.

    Wulan juga saat ini menjadi Psikolog di Rumah Perlindungan Trauma Center milik Kementerian Sosial yang memberikan perlindungan dan pemulihan psikososial pada korban tindak kekerasan (kekerasan berbagis gender, kekerasan dalam rumah tangga, serta human trafficking).`,
  },
  {
    name: 'Dyah Paramita Turner, S.Psi., CH., CHt.',
    skills: ['Meditation', 'Hypnotherapy', '+5'],
    skills_detail: [
      'Meditation',
      'Hypnotherapy',
      'Couple and family issues',
      'Hand writing analyst',
      'Personal development advisor',
      'Career counseling',
      'Experience in training',
    ],
    photo: PsychologistImages.Dyah,
    alt: 'Ibu Dyah',
    slug: 'dyah-paramita',
    profile:
      'Psikolog lulusan Universitas Indonesia, berlisensi serta memiliki pengalaman lebih dari 12 tahun menangani konseling bagi dewasa dan dewasa muda, secara individu, berpasangan, keluarga, serta kelompok.',
  },
  {
    name: 'Dra. Viera Adella, M.Psi., Psikolog',
    skills: ['School-related Problems', 'Special-need Problems (autism etc.)'],
    skills_detail: [
      'School-realted Problems',
      'Special-need Problems (autism etc.)',
    ],
    photo: PsychologistImages.Viera,
    alt: 'Ibu Viera',
    slug: 'viera-adella',
    profile: `Lulusan Fakultas Psikologi Universitas Padjadjaran jurusan Klinis Dewasa dan Magister Profesional Psikologi Universitas Padjadjaran jurusan Klinis Anak. Berpengalaman sebagai konsultan pada beberapa perusahaan. Saat ini menjabat sebagai dosen Fakultas Psikologi dan dosen Program Pendidikan S2 Magister Profesional Psikologi jurusan Klinis Universitas Atma Jaya serta sebagai Psychologist in Charge (Project Leader) Politeknik Sriwijaya, Palembang.

    Memiliki pengalaman workshop pada berbagai institusi sebagai ‘coach’ untuk refreshment penggunaaan perangkat diagnostik di dunia industri dan organisasi khususnya bagi para assessor.`,
  },
  {
    name: 'Raymond Tambunan, Psi., MSos.',
    skills: ['Hypnotherapist', '+4'],
    skills_detail: [
      'Family Counseling',
      'Self-Transformation Strategist',
      'Hypnotherapist',
      'Anthropology-cultural Sensitive',
      'Mindfulness Practitioner',
    ],
    photo: PsychologistImages.Raymond,
    alt: 'Bapak Raymond',
    slug: 'raymond-tambunan',
    profile: `Lulusan Fakultas Psikologi Universitas Indonesia dan mendapatkan gelar Master of Anthropology dari Fakultas Ilmu Sosial dan Ilmu Politik Universitas Indonesia. Selain memiliki pengalaman mengajar lebih dari dua belas tahun di universitas, Raymond Tambunan juga adalah hipnoterapis bersertifikat.

    Kegiatannya ketika menjabat sebagai dosen membuatnya lekat dengan riset. Topik-topik risetnya melingkupi social intervention to self-development.Pada tahun 2008 hingga 2010 menjabat sebagai Director of AIDS Research Center pada Universitas Atma Jaya, Jakarta. Pernah menjadi Koordinator untuk Indonesian Research Capacity Building pada University of Illinois, Chicago, pada tahun 2011-2013.`,
  },
  {
    name: 'Ika Putri Dewi, S.Psi., Psikolog',
    skills: ['Interest and talent', '+2'],
    skills_detail: [
      'Trauma (peristiwa yang sangat tidak menyenangkan, berbagai jenis kekerasan, bencana, kehilangan, dll)',
      'Klinis anak / anak dan remaja dengan berbagai gangguan emosinya.',
    ],
    photo: PsychologistImages.Ika,
    alt: 'Ibu Ika',
    slug: 'ika-putri-dewi',
    profile:
      'Ika Putri Dewi, psikolog anak dan remaja, yang sudah bergabung di Yayasan PULIH sejak tahun 2011 ; dan sekarang (per 2022) bergabung dalam keluarga Pulih@thePeak. Ika merupakan lulusan Atmajaya S1 pada tahun 1993, dan profesi psikologi pada tahun 2000.',
  },
  {
    name: 'Dra. Ammy Kadarharutami MD, M.Psi. Psikolog',
    skills: ['Marital Case', 'Parenting issues', '+1'],
    skills_detail: ['Performance Problem', 'Marital Case', 'Parenting issues'],
    photo: PsychologistImages.Ammy,
    alt: 'Ibu Ammy',
    slug: 'ammy-kadarharutami',
    profile:
      'Lulusan Fakultas Psikologi Universitas Padjadjaran jurusan Klinis Dewasa dan Magister Profesional Psikologi Universitas Padjadjaran jurusan Klinis Anak. Berpengalaman sebagai praktisi dan konsultan di beberapa perusahaan. Saat ini mengelola sebuah perusahaan konsultan yang bergerak dalam bidang pengelolaan SDM. Terbiasa menjalankan peran sebagai trainer, fasilitator dan asesor dalam dunia industry serta konselor dan professional coach untuk individu.',
  },
  {
    name: 'Astarini Retno Y (Ajeng Raviando), S.Psi., Psikolog',
    skills: ['Family Counseling', '+3'],
    skills_detail: [
      'Youth and Adult Psychologist',
      'Family Counseling',
      'Pre-marital and Marital Counseling',
      'Self-transformation Strategist',
    ],
    photo: PsychologistImages.Astarini,
    alt: 'Ibu Astarini',
    slug: 'astarini-retno',
    profile: `Ibu dari dua orang putri ini adalah lulusan Fakultas Psikologi Universitas Indonesia. Memiliki pengalaman lebih dari 20 tahun di bidang konseling, pelatihan, assessment, dan pengembangan diri.

    Astarini Retno atau lebih dikenal juga dengan nama Ajeng Raviando aktif sebagai Psikolog di Taman Hati Konseling dan Pulih@thePeak. Selain itu juga sebagai Fasilitator di Talk inc Jakarta dan di Look Modeling School Jakarta. Beliau juga aktif sebagai pembicara seminar, narasumber televisi, dan penulis untuk berbagai media di Indonesia.`,
  },
  {
    name: 'Andi Miriam Amiruddin, S.Psi., Psikolog',
    skills: ['Depresi', '+3'],
    skills_detail: [
      'Psikolog anak terkait dengan tumbuh kembang dan kematangan anak.',
      'Menangani pengukuran kecerdasan dan minat bakat siswa.',
      '​Konseling Pernikahan',
      'Konseling untuk relasi dalam pra nikah dan pernikahan.',
    ],
    photo: PsychologistImages.Andi,
    alt: 'Ibu Andi',
    slug: 'andi-miriam',
    profile:
      'Lulusan Fakultas Psikologi jurusan Perkembangan, Universitas Surabaya. Memiliki pengalaman diantaranya di bidang Psikologi Perkembangan : melakukan pemeriksaan dan konsultasi terkait tumbuh kembang, dan kematangan anak. Di bidang Psikologi Pendidikan : melakukan pemeriksaan dan konsultasi terkait  pengukuran kecerdasan serta minat & bakat siswa. Di bidang Psikologi Industri : melakukan assessment dan feedback terkait pemenuhan kompetensi, rekrutmen, dan promosi.',
  },
  {
    name: 'Yeny Duriana Wijaya, M.Psi., Psikolog',
    skills: ['Youth & Adult', '+3'],
    skills_detail: [
      'Remaja dan Dewasa',
      'Konseling individu : relasi, depresi, kecemasan, masalah remaja',
      'Konseling pasangan : pernikahan, pranikah,',
      'Konseling kelompok: isu gender, atau traumatis',
    ],
    photo: PsychologistImages.Yenny,
    alt: 'Ibu Yeni',
    slug: 'yeni-duriana',
    profile: `Menempuh Pendidikan di Magister Psikologi Profesi Klinis di Universitas Gadjah Mada. Saat ini aktif menjalankan praktek konseling dan psikoterapi di Unit Pelayanan Psikologi, Fak Psikologi Universitas Esa Unggul. Selain itu juga bekerja sebagai dosen tetap Fak Psikologi, di Universitas Esa Unggul  yang mengajar mata kuliah bidang psikologi klinis, psikopatologi, psikoterapi. 

    Ketertarikan terkait masalah depresi, kecemasan, relasi antara pasangan (suami istri, atau keluarga), masalah remaja dan isu2 terkait masalah kekerasan terhadap perempuan dan anak.`,
  },
  {
    name: 'Widaningrum, S.Psi., Psikolog',
    skills: ['Youth and Adult Psychologist', 'Human Resources Consultant'],
    skills_detail: [
      'Youth and Adult Psychologist',
      'Human Resources Consultant',
    ],
    photo: PsychologistImages.Widaningrum,
    alt: 'Ibu Widaningrum',
    slug: 'widaningrum',
    profile:
      'Lulusan Fakultas Psikologi Universitas Padjadjaran. Memiliki pengalaman lebih dari 20 tahun di bidang pengembangan Sumber Daya Manusia (Human Resources), pengembangan organisasi, assessment, konseling (individual/karyawan). Widaningrum juga menangani proyek terkait dengan pengembangan SDM di organisasi baik BUMN maupun Swasta. Selain itu juga adalah seorang praktisi HR di korporasi dan konsultan pada lembaga konsultan.',
  },
  {
    name: 'Mersedes Tanok, M.Psi., Psikolog',
    skills: ['Job Profile', 'Talent Acquisition', '+6'],
    skills_detail: [
      'Menangani Kesulitan Belajar Pada Anak',
      'Menangani Masalah Psikologis Anak dan Dewasa',
      'Tes Minat dan Bakat (Penjurusan)',
      'Kesiapan Masuk Sekolah',
      'Konseling Keluarga',
      'Assessment Center',
      'Talent Acquisition',
      'Job Profile',
    ],
    photo: PsychologistImages.Mersedes,
    alt: 'Ibu Mersedes',
    slug: 'mersedes-tanok',
    profile: `Lulusan Fakultas Psikologi jurusan Perkembangan Universitas Padjadjaran. Pengalaman kerja sebagai recruiter salah satu anak perusahaan Astra dan kemudian menduduki beberapa posisi managerial di bidang Human Resources pada perusahaan multinasional. Menjabat sebagai Talent and Acquisition General Manager pada perusahaan komoditi di Jakarta hingga 2017.

    Mersedes Tanok sempat beberapa kali diundang perguruan tinggi negeri di Jakarta sebagai pembicara tentang dunia kerja dan terlibat dalam asistensi mahasiswa psikologi Atma Jaya dalam penanganan kasuistik. Pada tahun 2017 memutuskan untuk fokus pada dunia konseling.`,
  },
  {
    name: 'Dra. Diah Astarini',
    skills: ['Konseling Pernikahan', 'Hubungan Perkawinan'],
    skills_detail: ['Konseling Pernikahan', 'Hubungan Perkawinan'],
    photo: PsychologistImages.Diah,
    alt: 'Ibu Diah',
    slug: 'diah-astarini',
    profile: `Lulusan Fakultas Psikologi Universitas Indonesia tahun 1994. Mengikuti kursus Educational & Helping Child Course pada tahun 1995 di Fakultas dan Universitas yang sama. Seorang certified hypnotherapist, certified negotiation specialist dan marketing strategist.

    Berpengalaman dalam bidang training dan pembicara pada beberapa acara diantaranya “Peran Orang Tua Terhadap Kemampuan Berpikir Kognitif Anak Usia Balita” (Gramedia-1998), “Do Not Running From U’r Problem” (dbb/vertigo-2004), dan “Self Motivation For Better Life” (SMART Concept-Manulife Indonesia 2008).`,
  },
  {
    name: 'Rika Ermasari, Psikolog',
    skills: ['Stres dan Kesehatan', 'Depresi', '+1'],
    skills_detail: [
      'Hypnotherapy',
      'Direction Technique/Non Hypnotherapy',
      'Cognitive Behavior Therapy',
      'Acceptance Therapy',
      'HR all areas',
      'Culture Change',
      'Executive Coaching',
      'People Development',
      'Recruitment',
      'Assessment',
    ],
    photo: PsychologistImages.Rika,
    alt: 'Ibu Rika',
    slug: 'rika-ermasari',
    profile:
      'Memiliki pengalaman 20 tahun sebagai HR Executive. Rika menekuni passionnya sebagai psikolog hingga saat ini dan mendapatkan sertifikasi sebagai coach dari ICF serta memiliki banyak sertifikasi di bidang Psikoterapi dan terus mengupdate skillnya sebagai terapis.',
  },
  {
    name: 'Ariesti Pritawati, M. Psi., Psikolog',
    skills: ['Konseling individu', 'Konseling pasangan'],
    skills_detail: [
      'Konseling individu : relasi, penyesuaian diri, optimalisasi peran, dsb.',
      'Konseling pasangan : pranikah, pernikahan.',
    ],
    photo: PsychologistImages.Ariesti,
    alt: 'Ibu Ariesti',
    slug: 'ariesti-pritawati',
    profile: `Psikolog Klinis Dewasa yang menempuh pendidikan Magister Profesi Psikolog jurusan Klinis Dewasa di Unika Atma Jaya Jakarta. Saat ini aktif menjalani praktik konseling dan psikoterapi pada klien usia 17 tahun keatas. 
    
    Ariesti memiliki minat pada isu-isu seputar relasi (relasi pasangan, relasi ibu-anak, dsb) dan optimalisasi peran individu. Selain itu juga aktif menjadi dosen pembimbing kasuistik bagi mahasiswa profesi Psikolog Klinis Dewasa di Fakultas Psikologi Unika Atma Jaya Jakarta.`,
  },
  {
    name: 'Shanen Emily, M.Psi., Psikolog',
    skills: ['Depresi', 'Kecemasan', '+2'],
    skills_detail: [
      'Depresi, Kecemasan, dan Trauma',
      'Stres dan Kesehatan',
      'Relasi dengan Pasangan',
      'Pengembangan Diri',
    ],
    photo: PsychologistImages.Shanen,
    alt: 'Ibu Shanen',
    slug: 'shanen-emily',
    profile: `Shanen Emily adalah lulusan Magister Profesi Psikologi Klinis Dewasa UNIKA Atma Jaya. Memiliki ketertarikan terhadap isu-isu yang berkaitan dengan kesejahteraan emosional individu di dalam keluarga dan relasi berpasangan.
    
    Selain itu, Shanen juga menangani persoalan pada remaja dan dewasa, khususnya pada area pengembangan diri, karir, dan hubungan interpersonal. Sejumlah kasus stres yang berkaitan dengan kondisi kesehatan fisik juga ditangani oleh Shanen. Saat ini, Shanen juga aktif berperan sebagai asesor untuk keperluan rekrutmen perusahaan.`,
  },
  {
    name: 'Prita Pradipta, M.Psi., Psikolog',
    skills: ['Pengampunan', 'Manajemen stress', '+3'],
    skills_detail: [
      'Depresi dan kecemasan',
      'Manajemen stress',
      'Relasi dengan pasangan',
      'Pengampunan',
      'Pertumbuhan diri',
    ],
    photo: PsychologistImages.Prita,
    alt: 'Ibu Prita',
    slug: 'prita-pradipta',
    profile:
      'Prita Pradipta merupakan lulusan Magister Psikologi Profesi Kekhususan Klinis Dewasa UNIKA Atma Jaya. Prita memiliki ketertarikan terhadap isu yang berkaitan dengan pertumbuhan diri individu dan relasi pasangan. Prita juga memiliki pengalaman menangani masalah terkait dengan kecemasan, depresi, manajemen stress, perselingkuhan dalam relasi romantis, serta LGBT.',
  },
  {
    name: 'Bella Amanda Maharani, M.Psi., Psikolog',
    skills: ['Klinis', 'Minat Bakat', '+1'],
    skills_detail: ['Klinis', 'Konseling Orang Tua', 'Minat Bakat'],
    photo: PsychologistImages.Bella,
    alt: 'Ibu Bella',
    slug: 'bella-amanda',
    profile:
      'Bella Amanda Maharani merupakan psikolog klinis anak dan remaja lulusan Universitas Padjajaran. Memiliki ketertarikan pada masalah anak dan remaja. Berpengalaman melakukan asesmen klinis, minat bakat, dan konseling orang tua.',
  },
  {
    name: 'Hanina Maulidha, M.Psi., Psikolog',
    skills: ['Bullying', 'Minat Bakat', 'Emosi', '+5'],
    skills_detail: [
      'Anak dan Remaja',
      'Bullying',
      'Counseling Career',
      'Minat Bakat',
      'Emosi',
      'Kesiapan Sekolah',
      'Hambatan Belajar',
      'Kekerasan pada Perempuan dan Anak',
    ],
    photo: PsychologistImages.Hanina,
    alt: 'Ibu Hanina',
    slug: 'hanina-maulidha',
    profile:
      'Hanina Maulidha merupakan Psikolog Pendidikan yang merupakan lulusan dari Magister Profesi Psikologi UNTAR (Universitas Tarumanegara). Selain itu menjadi Founder @speakupnow.id yang merupakan Social Enterprise bergerak di bidang Pendidikan Public Speaking dan Psikologi untuk Anak dan Remaja. Hanina juga aktif sebagai Konselor Kekerasan pada Perempuan dan Anak di P2TP2A Provinsi DKI Jakarta dan menjadi Psikolog Sekolah di salah satu SMP Swasta di Jakarta.',
  },
  {
    name: 'Angellia Lestari Christiani, M.Psi., Psikolog',
    skills: ['Sexual Orientation', 'Self Development', '+1'],
    skills_detail: [
      'Romantic Relationship with Partner',
      'Sexual Orientation',
      'Self Development',
    ],
    photo: PsychologistImages.Angelia,
    alt: 'Ibu Angellia',
    slug: 'angellia-lestari',
    profile:
      'Angellia Lestari Christiani, lebih akrab dipanggil dengan Angel merupakan lulusan Psikologi Klinis Dewasa dari Unika Atma Jaya Jakarta. Ketertarikannya dalam isu relasi dan orientasi seksual terlihat dari pengalamannya menangani konseling individual, maupun pasangan dengan topik terkait. Angel telah bergabung di Pulih@thePeak sejak 2019, serta aktif sebagai pembicara di berbagai Webinar dan Training. Angel juga merupakan dosen honorer di salah satu universitas swasta di Jakarta. Saat ini, Angel juga praktik konseling di @bicarakan.id dan @grome (Grow with Fame Consultant).',
  },
  {
    name: 'Niken Paramita, M.Psi., Psikolog',
    skills: ['Bakat Siswa', 'Anak dan Remaja'],
    skills_detail: [
      'Menangani pengukuran kecerdasan dan minat bakat siswa',
      'Menangani kesulitan belajar anak dan remaja',
    ],
    photo: PsychologistImages.Niken,
    alt: 'Ibu Niken',
    slug: 'niken-paramita',
    profile:
      'Psikolog klinis dewasa yang mengenyam Pendidikan S1 Fakultas Psikologi Unika Atma Jaya dan Program Magister Profesi Klinis Dewasa Unika Atma Jaya. Memiliki pengalaman diantaranya di bidang Psikologi Pendidikan: melakukan pemeriksaan dan konsultasi terkait  pengukuran kecerdasan serta minat dan bakat siswa, serta menangani kesulitan belajar anak dan remaja. Di bidang Psikologi Industri: melakukan assessment dan feedback terkait pemenuhan kompetensi, rekrutmen, dan promosi.',
  },
  {
    name: 'Rini Ariani, M. Psi., Psikolog',
    skills: ['⁠Asesmen Psikologis', 'Intervensi Edukasi', '+6'],
    skills_detail: [
      '⁠Asesmen Psikologis',
      'Intervensi Edukasi',
      'Bimbingan dan Konseling Edukasi',
      'Pendampingan Siswa',
      'Konsultasi Guru dan Orang Tua',
      'Deteksi Dini Masalah',
      'Intervensi Kesehatan Mental',
      'Promosi Kesehatan Mental',
    ],
    photo: PsychologistImages.Ariani,
    alt: 'Ibu Rini',
    slug: 'rini-ariani',
    profile:
      'Rini Ariani, S. Psi., M. Psi., Psikolog, adalah psikolog pendidikan dengan pengalaman lebih dari 15 tahun dalam mendampingi anak dan remaja. Ia menyelesaikan studi Sarjana Psikologi di Universitas Paramadina melalui program Paramadina Fellowship yang didanai penuh oleh Newmont Mining Corporation, serta meraih Magister Profesi Psikologi Pendidikan Anak dan Remaja dari Universitas Atma Jaya Jakarta. Rini pernah aktif berkontribusi di berbagai lembaga pendidikan seperti Perguruan Islam Al-Izhar Pondok Labu. Saat ini Rini aktif di Yayasan Inspirasi Pembelajar sebagai direktur experiential based learning dan psikolog sekolah, serta menjalankan praktik di Inspirasi Consulting. Ia juga terlibat dalam pengembangan profesional melalui peran sebagai pengurus pusat Asosiasi Psikologi Pendidikan Indonesia di bawah HIMPSI.\n\nLayanan yang Ditawarkan:\n1. Asesmen Psikologis Pemeriksaan kemampuan kognitif dan gaya belajar, identifikasi kesulitan belajar dan kebutuhan anak berkebutuhan khusus (ABK), serta penilaian perkembangan sosial-emosional anak.\n2. Intervensi Edukasional Program remedial learning bagi siswa dengan hambatan belajar, perancangan pembelajaran inklusif untuk siswa ABK, dan konseling akademik terkait manajemen waktu dan motivasi belajar.\n3. Bimbingan dan Konseling Pendidikan Sesi individu dan kelompok untuk isu akademik atau perilaku, serta sosialisasi tema seperti bullying, stres ujian, pubertas, dan tekanan teman sebaya.\n4. Pendampingan Siswa Pelatihan keterampilan sosial (social skills training) dan pengembangan keterampilan hidup (life skills) untuk anak dan remaja.\n5. Konsultasi Guru dan Orang Tua Rekomendasi strategi belajar yang sesuai kebutuhan psikologis siswa dan workshop parenting dengan berbagai topik perkembangan anak dan remaja.\n\nLayanan Khusus Kesehatan Mental:\n1. Deteksi Dini Masalah Mental Skrining gangguan emosional seperti kecemasan, stres, dan depresi, serta identifikasi perilaku menyimpang seperti bullying atau self-harm.\n2. Intervensi Kesehatan Mental Terapi kognitif-perilaku (CBT) untuk anak dan remaja, serta konseling trauma pasca-kejadian krisis seperti bencana atau kekerasan.\n3. Promosi Kesehatan Mental Edukasi dan kampanye kesadaran kesehatan mental di sekolah, serta pelatihan manajemen stres dan regulasi emosi.\nTersedia: Hanya Online',
  },
  {
    name: 'Upik Nuri Budi Sulistyorini., S. Psi. Psikolog',
    skills: [
      'Youth (Scholl-related problems)',
      'Carrier Counselling (related problems)',
      '+2',
    ],
    skills_detail: [
      'Youth (Scholl-related problems)',
      'Carrier Counselling (related problems)',
      'Personal Counseling (related problems)',
      'Couple Counseling (Pre Marriage, Married)',
    ],
    photo: PsychologistImages.Upik,
    alt: 'Ibu Upik',
    slug: 'upik',
    profile:
      'Lulusan Fakultas Psikologi Universitas Surabaya (Ubaya) Surabaya, pada tahun 1993. Sempat bergabung menjadi professional SDM di salah satu perusahaan swasta Jakarta dan kemudian membuka Biro Psikologi. Hingga saat ini bergabung juga sebagai Counselor, Assessor dan Psychologist Associate di beberapa Biro Psikologi.',
  },
  {
    name: 'Silvia Hanny Liestyani, M.Psi., Psikolog',
    skills: [
      'Remaja & Dewasa',
      'Pasangan/Pra-Nikah',
      'Pengembangan Diri',
      'Karir & Performa',
    ],
    skills_detail: [
      'Remaja & Dewasa',
      'Pasangan/Pra-Nikah',
      'Pengembangan Diri',
      'Karir & Performa',
    ],
    photo: PsychologistImages.Silvia,
    alt: 'Ibu Silvia',
    slug: 'silvia-hanny',
    profile:
      'Lulusan Fakultas Psikologi, Universitas Maranatha Bandung, dan Magister Profesi Psikologi jurusan Klinis Dewasa, Universitas Atma Jaya Jakarta. Memiliki pengalaman diantaranya di bidang Psikologi Pendidikan, melakukan pemeriksaan terkait kecerdasan serta minat & bakat. Di bidang Industri & Organisasi, melakukan assessment dan feedback terkait pemenuhan kompetensi, rekrutmen, dan promosi. Di bidang Klinis, melakukan konseling individual. Saat ini menjabat sebagai dosen Fakultas Psikologi dan pembimbing kasus di Magister Profesi Psikologi jurusan Klinis Dewasa, Universitas Atma Jaya.',
  },
  {
    name: 'Sylvia Dewi, M.Psi, Psikolog',
    skills: [
      'Regulasi emosi',
      'Depresi, stres dan kecemasan',
      'Kedukaan',
      'Pengembangan diri dan perencanaan karir',
      'Relasi dan dinamika di dalam keluarga',
    ],
    skills_detail: [
      'Regulasi emosi',
      'Depresi, stres dan kecemasan',
      'Kedukaan',
      'Pengembangan diri dan perencanaan karir',
      'Relasi dan dinamika di dalam keluarga',
    ],
    photo: PsychologistImages.Sylvia,
    alt: 'Ibu Sylvia',
    slug: 'sylvia-dewi',
    profile:
      'Lulusan Magister Psikologi Profesi Klinis Unika Atma Jaya. Mengawali karir di bidang industri organisasi, kemudian mendalami psikologi profesi klinis. Memiliki ketertarikan terhadap berbagai isu kesehatan mental, seperti depresi, kecemasan, trauma dan kedukaan. Sylvia juga memiliki ketertarikan terhadap dinamika dan relasi di dalam keluarga, khususnya pada keluarga dengan anak berkebutuhan khusus. Memiliki pengalaman dalam penyelenggaraan berbagai program pengembangan diri, baik dalam lingkup individu, kelompok, maupun organisasi. Sylvia meyakini bahwa setiap individu memiliki keunikan dan potensinya tersendiri, serta memiliki kesempatan untuk mewujudkannya.',
  },
  {
    name: 'B. Sri Susanti, S.Psi, Psikolog, CH., CHt',
    skills: ['Pre-marriage', 'Marriage', 'Family', '+2'],
    skills_detail: [
      'Pre-marriage',
      'Marriage',
      'Family',
      'Pengembangan Diri',
      'Permasalahan terkait individu',
    ],
    photo: PsychologistImages.Susanti,
    alt: 'Ibu Sri Susanti',
    slug: 'sri-susanti',
    profile:
      'Merupakan lulusan Fakultas Psikologi Universitas Surabaya dengan fokus bidang klinis. Pengalaman di bidang pendidikan merupakan pembelajaran untuk lebih mengenal remaja dengan segala macam cerita kehidupan.\n\nBerlanjut dengan terjun di bidang industri dan organisasi, mengikuti kegiatan asesmen terkait pemenuhan kompetensi, rekrutmen dan promosi.\n\nDi bidang klinis  untuk individu dengan berbagai problematika hidup yang menyebabkan timbulnya berbagai macam gangguan seperti cemas, trauma dan juga permasalahan di bidang pekerjaan.Berpengalaman dalam menangani pasangan baik yang belum menikah maupun yang sudah menjalani pernikahan juga terkait permasalahan dalam keluarga.',
  },
  {
    name: 'Frisca Priscilia Boentario, S.Psi., M.Psi., Psikolog',
    skills: ['Depression', 'Anxiety', '+6'],
    skills_detail: [
      'Depression',
      'Anxiety',
      'Personal growth',
      'Family therapy',
      'Relationships ',
      'Trauma',
      'Teen',
      'English-speaking clients',
    ],
    photo: PsychologistImages.Frisca,
    alt: 'Ibu Frisca Priscilia',
    slug: 'frisca-priscilia',
    profile:
      'Frisca adalah seorang Psikolog Klinis Dewasa yang memperoleh gelar profesionalnya dari Universitas Tarumanagara. Sebelumnya, ia telah menyelesaikan gelar Sarjana Sains (B.Sc Hons) dari City University of London dan gelar Magister Sains (M.Sc) dari University of Surrey. Sebagai warga negara Indonesia yang telah tinggal di Inggris selama 5 tahun, ia memiliki kompetensi untuk menangani berbagai klien yang berasal dari latar belakang budaya yang berbeda.\n\nFrisca sebagian besar menangani klien mulai dari remaja akhir hingga dewasa. Ia menerapkan berbagai perawatan berbasis bukti dalam sesi terapinya, yang disesuaikan dengan kebutuhan spesifik klien.',
  },
  {
    name: 'Prasti Wardani, M.Si., Psikolog',
    skills: ['Caregiver', 'Psychologist'],
    skills_detail: ['Caregiver', 'Psychologist'],
    photo: PsychologistImages.Prasti,
    alt: 'Ibu Prasti Wardani',
    slug: 'prasti-wardani',
    profile:
      'Seorang Psikolog sekaligus praktisi di bidang Pengembangan Sumber Daya Manusia dan Organisasi dengan pengalaman lebih dari 15 tahun di perusahaan multinasional. Keahliannya mencakup pengembangan talenta, peningkatan kapabilitas organisasi, serta pendampingan transformasi sumber daya manusia. Selain perjalanan profesionalnya, beliau juga memiliki pengalaman personal sebagai caregiver mendampingi almarhum ayah yang menderita Alzheimer. Pengalaman ini memperkuat kepedulian dan komitmennya dalam isu perawatan lansia serta pendamping keluarga. Saat ini, beliau juga berperan sebagai Mitra Profesional di Pulih at The Peak, dengan fokus pada konsultasi dan penanganan tantangan yang dihadapi caregiver Alzheimer dan lansia.',
  },
  {
    name: 'Veny Oktaviani, M.Psi.,Psikolog',
    skills: ['Anxiety', 'Depression', '+6'],
    skills_detail: [
      'Anxiety',
      'Depression',
      'Mood & Stress',
      'Behavioral & Emotional Disorders',
      'Interpersonal Relationships',
      'Self-Image Issues',
      'Sleep Problems',
      'Addictive Behaviors',
    ],
    photo: PsychologistImages.Veny,
    alt: 'Ibu Veny Oktaviani',
    slug: 'veny-oktaviani',
    profile:
      'Veny Oktaviani adalah seorang Psikolog Klinis lulusan Universitas Tarumanagara. Sebagai Psikolog Klinis, Veny berdedikasi untuk membantu individu berkembang dengan meningkatkan kesejahteraan emosional dan ketahanan diri. Veny menawarkan dukungan personal berbasis bukti dalam lingkungan yang penuh kasih dan aman—memberdayakan individu untuk mengatasi tantangan dan menjalani kehidupan yang lebih seimbang dan memuaskan. Ia memiliki minat di bidang Psikologi Forensik dan Perkembangan Anak.',
  },
  {
    name: 'Nabila Nafisa',
    skills: [
      '⁠Penilaian minat dan bakat',
      'Bimbingan karir dan perencanaan pendidikan',
    ],
    skills_detail: [
      '⁠Penilaian minat dan bakat',
      'Bimbingan karir dan perencanaan pendidikan',
    ],
    photo: PsychologistImages.Nafisa,
    alt: 'Ibu Nabila Nafisa',
    slug: 'nabila-nafisa',
    profile:
      'Nabila Nafisa menyelesaikan Magister Profesional Psikologi Klinis di Universitas Gadjah Mada. Ia memiliki minat yang kuat dalam bimbingan karier dan pengembangan bakat. Nabila berpengalaman dalam melaksanakan dan menginterpretasi asesmen psikologis, terutama yang berkaitan dengan kecerdasan, kepribadian, minat, dan bakat, untuk membantu memahami potensi mereka dan membuat keputusan pendidikan dan karier yang tepat bagi individu.\nTersedia: Online & Offline',
  },
  {
    name: 'Nursila Dewi, Psi, MSc',
    skills: ['Kesehatan Mental', 'Pengembangan Pribadi', '+2'],
    skills_detail: [
      'Kesehatan Mental',
      'Pengembangan Pribadi',
      'Pengembangan Modal Manusia',
      'Perubahan/transisi/krisis, pra- dan pasca-menopause',
    ],
    photo: PsychologistImages.Nursila,
    alt: 'Ibu Nursila Dewi, Psi, MSc',
    slug: 'nursila-dewi',
    profile:
      'Nursila Dewi, Psi, MSc lulus dari Universitas Indonesia dan memiliki gelar master di bidang pengembangan sumber daya manusia dari Universitas Manchester. Ia menghabiskan hampir dua dekade bekerja dengan organisasi internasional di Indonesia dan luar negeri.\n\nIa tertarik untuk mendukung individu dan organisasi dalam beradaptasi dan menyesuaikan diri dengan perubahan dan transisi, termasuk perempuan di atas 40 tahun saat mereka menghadapi pergeseran identitas diri dan karier, serta perimenopause, menopause, dan pascamenopause.\n\nSila berbicara bahasa Indonesia dan Inggris.\nTersedia: Online & Offline',
  },
  {
    name: 'Madyastha Aji Bhirawa, M.Psi., Psikolog',
    skills: ['Kesehatan Mental', 'Pengembangan Pribadi', '+2'],
    skills_detail: [
      'Kesehatan Mental',
      'Pengembangan Pribadi',
      'Pengembangan Modal Manusia',
      'Perubahan/transisi/krisis, pra- dan pasca-menopause',
    ],
    photo: PsychologistImages.Madyastha,
    alt: 'Madyastha Aji Bhirawa, M.Psi., Psikolog',
    slug: 'madyastha-aji',
    profile:
      'Madyastha Aji Bhirawa, M.Psi., Psikolog adalah seorang Psikolog Klinis, Konsultan Transformasi Organisasi, serta Perancang Solusi dan Potensi Manusia. Ia memiliki keahlian dalam asesmen psikologis, psikologi klinis, *coaching*, pengembangan diri, asesmen talenta dan kepemimpinan, budaya organisasi, serta solusi strategis terkait sumber daya manusia.\n\nAji merupakan lulusan Program Profesi Psikologi (bidang Psikologi Klinis) dari Universitas Katolik Atma Jaya. Saat ini, ia menjabat sebagai *Chief Solution Design and Management* di ACT Consulting, ESQ, di mana ia memimpin perancangan dan pengelolaan solusi organisasi serta modal manusia yang berorientasi pada kebutuhan klien. Ia juga aktif sebagai Dosen di Universitas Ary Ginanjar, berkontribusi dalam pendidikan psikologi melalui kegiatan pengajaran, perancangan pembelajaran, dan asesmen.\n\nDengan memadukan ilmu psikologi, perilaku manusia, dan strategi organisasi, Aji bekerja pada tingkat individu maupun organisasi. Ia membantu individu untuk memahami diri sendiri, menggali potensi, dan menciptakan perubahan yang bermakna, sekaligus membantu organisasi dalam mengembangkan talenta, kepemimpinan, budaya, dan solusi sumber daya manusia yang memberikan dampak berkelanjutan.\nTersedia: Online',
  },
  {
    name: ' ⁠Inayah R. Dayyan',
    skills: ['Tes & Asesmen Psikologis', 'Interpretasi Tes Psikologis', '+5'],
    skills_detail: [
      'Tes & Asesmen Psikologis',
      'Interpretasi Tes Psikologis',
      'Penulisan Laporan Psikologis',
      'Observasi Psikologis',
      'Pusat Asesmen & LGD',
      'Komunikasi Interpersonal',
      'Wawancara & Konseling Dasar',
    ],
    photo: PsychologistImages.Inayah,
    alt: '⁠Inayah R. Dayyan',
    slug: 'inayah',
    profile:
      'Lulusan Fakultas Psikologi Universitas Gunadarma dan memiliki gelar Magister Psikologi dari Universitas Persada Indonesia Y.A.I. Memiliki pengalaman di bidang Psikologi Pendidikan (melakukan asesmen psikologis terkait kemampuan anak, kesiapan sekolah, dan kebutuhan pendidikan khusus), Psikologi Industri & Organisasi (melakukan asesmen terkait rekrutmen, kompetensi, dan kebutuhan organisasi), serta Psikologi Klinis (melakukan asesmen psikologis dan konseling). Juga berpengalaman sebagai trainer dan pembicara untuk anak-anak, remaja, serta program pendidikan.\nTersedia: Online & Offline',
  },
  {
    name: ' Alang Gumilang Berlian, S.Psi. M.Psi,. Psikolog',
    skills: ['Asesmen rekrutmen', 'Konseling untuk anak, remaja dan dewasa', '+2'],
    skills_detail: [
      'Asesmen rekrutmen',
      'Konseling untuk anak, remaja dan dewasa',
      'Pelatihan fasilitator/konsultan pengembangan SDM',
      'Pelatihan fasilitator/konsultan pengembangan dunia pendidikan',
    ],
    photo: PsychologistImages.Alang,
    alt: 'Alang Gumilang Berlian, S.Psi. M.Psi,. Psikolog',
    slug: 'alang-gumilang',
    profile:
      'Alang Gumilang Berlian, S.Psi. M.Psi. Psikolog adalah praktisi psikologi industri dan organisasi. Ia berpengalaman di ranah akademis dan penelitian.\nTersedia: Online & Offline',
  },
  {
    name: 'Maria Natalie, M.Psi., Psikolog',
    skills: ['Psikologi Pendidikan'],
    skills_detail: [
      'Psikologi Pendidikan',
    ],
    photo: PsychologistImages.Maria,
    alt: 'Maria Natalie, M.Psi., Psikolog',
    slug: 'maria-natalie',
    profile:
      'Lulusan Fakultas Psikologi dan memiliki gelar Magister Psikologi Profesi dari Universitas Katolik Indonesia Atma Jaya. Memiliki spesialisasi di bidang Psikologi Pendidikan, dengan pengalaman dalam melakukan asesmen psikologis yang berfokus pada kemampuan kognitif anak, kebutuhan perkembangan, kesiapan bersekolah, kesulitan belajar, serta anak dengan kebutuhan khusus. Berpengalaman dalam memberikan layanan psikologis melalui biro psikologi dan bekerja sama dengan berbagai sekolah untuk mendukung pembelajaran, perkembangan, dan kebutuhan pendidikan anak, termasuk memberikan rekomendasi yang disesuaikan secara individual bagi anak dengan profil belajar dan perkembangan yang beragam. Selain itu, juga memberikan konsultasi dan bimbingan bagi orang tua serta pendidik guna mendukung pertumbuhan dan perkembangan anak secara optimal.\nTersedia: Online & Offline',
  },
];

export default psychologistList;
